import React from "react";
import { Link as TagLink } from "react-router-dom";
import "./_styles.scss";
import { Loader2 } from "lucide-react";

interface IButtonProps {
  size: string;
  children: any;
  disabled?: boolean;
  variant?: "primary" | "secondary" | "tertiary" | "danger";
  onClick?: any;
  id?: string;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
}
interface ILinkProps extends IButtonProps {
  to: string;
}

const Button = (props: IButtonProps) => {
  const {
    children,
    size = "md",
    variant = "primary",
    loading,
    ...rest
  } = props;
  return (
    <button
      className={`btn btn--${size} btn--${variant} ${loading && "loading"}`}
      disabled={loading}
      {...rest}
    >
      {loading ? <Loader2 size={20} className="btn__spinner" /> : children}
    </button>
  );
};

export const Link = (props: ILinkProps) => {
  const { children, size = "md", variant = "primary" } = props;
  return (
    <TagLink className={`btn btn--${size} btn--${variant}`} {...props}>
      {children}
    </TagLink>
  );
};

export const ButtonGroup = (props: any) => {
  return (
    <div className={`button-group-wrapper ${props.flexContent}`}>
      {props.children}
    </div>
  );
};

export default Button;
